import { CommApiInstance } from "Utils/CommApiInstance";

const GameTstrApi = async (
    gameSvcCd:string,
    
) => {
    return await CommApiInstance.post(`${gameSvcCd}/tstr`,{
        apiBody:{
        },
    })
    .then((Resp) => Resp.data);
}
export default GameTstrApi;